import { Card } from 'flowbite-react'
import React from 'react'
import { RiBaseStationLine } from "react-icons/ri";


interface IStudentCard {
  type?: any,
  text: string,
  count: any
}


const StudentActvieCard = ({ text, count, type }: IStudentCard) => {
  return (
    <div className="max-w-sm mx-5">
      {type === "active" && count > 0 ? (
        <Card
          style={{ width: "14rem" }}
          className={
            type === "active"
              ? "bg-green-500 bg-opacity-80 rounded-2xl rounded-2xl border-1 border-gray-100"
              : ""
          }
        >
          <div className='flex items-center'>
            <RiBaseStationLine className='text-white text-xl' />
            <h5 className="text-xl text-white tracking-wide text-left align-text-top uppercase font-medium font-semibold ml-2">
              {text}
            </h5>
          </div>
          <div>
            <h5 className="text-xl text-white tracking-wide text-left font-normal font-semibold">
              {count}
            </h5>
          </div>
        </Card>
      ) : (
        <Card
          style={{ width: "14rem" }}
          className="outline-black rounded-2xl border-2 border-gray-100"
        >
          <div>
            <h5 className="text-xl text-white tracking-wide text-left align-text-top uppercase font-medium font-semibold">
              {text}
            </h5>
          </div>
          <div>
            <h5 className="text-xl text-white tracking-wide text-left font-normal font-semibold">
              {count}
            </h5>
          </div>
        </Card>
      )}
    </div>
  );
}

export default StudentActvieCard

// "bg-green-600 opacity-90"